import InduccionContainer from "./InduccionContainer";

export default InduccionContainer;